"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainEventItem = exports.chainEventsSlice = void 0;
const react_1 = require("react");
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const FETCH_TIMEOUT = 1000 * 25;
exports.chainEventsSlice = toolkit_1.createSlice({
    name: 'ChainEvents',
    initialState: {},
    reducers: {
        watchEvent: (state, action) => {
            console.log('WATCH CALLED!', action);
            if (!state[action.payload.id]) {
                state[action.payload.id] = action.payload;
            }
        },
        unwatchEvent: (state, action) => {
            console.log('UNWATCH CALLED!', action);
            if (!!state[action.payload.id]) {
                delete state[action.payload.id];
            }
        },
        eventUpdated: (state, action) => {
            console.log('UPDATING ACTION', action.payload.id);
            state[action.payload.id] = action.payload;
        },
    },
});
const refreshPendingThunk = toolkit_1.createAsyncThunk('data/refreshPending', async (payload, thunk) => {
    var _a;
    const state = thunk.getState();
    // Only applies to the fully signed in and initialized state...
    if (!state.data.init.initialized || !((_a = state.connection.account.user) === null || _a === void 0 ? void 0 : _a.userId)) {
        return;
    }
    const we = state.data.watchEvents;
    const items = Object.values(we);
    console.log('WATCHING ', { we });
    // Group by event type..
    items.forEach(async (et) => {
        const eventItem = et;
        const updater = eventItem.updater;
        const res = await updater(eventItem, thunk.dispatch);
        console.log('UPDATED EVENT', { res });
        if (!!res) {
            if (res.status !== 'pending') {
                console.log('UNWATCHING', { res });
                thunk.dispatch(exports.chainEventsSlice.actions.unwatchEvent(res));
            }
            else {
                thunk.dispatch(exports.chainEventsSlice.actions.eventUpdated(res));
            }
        }
    });
});
const init = {};
function kickOff(dispatch) {
    if (!!init.init) {
        return;
    }
    init.init = true;
    // Periodically ping
    if (window) {
        window.setInterval(() => {
            dispatch(refreshPendingThunk({}));
        }, FETCH_TIMEOUT);
    }
}
/**
 * This component will manage a watchable event. Wrap watchable events in this component.
 * It will call the bakend periodically to update the event status.
 *
 * To watch for an event update listen to the following action:
 * - chainEventSclie.eventUpdated action
 *
 * For example:
 *  <ChainEventItem id="0x..." network="ETHEREUM" initialState="" eventType="transaction">
 *     <TranscationViewer ... />
 *  </ChainEventItem>
 */
function ChainEventItem(props) {
    const dispatch = react_redux_1.useDispatch();
    const { network, id, initialStatus, event } = props;
    react_1.useEffect(() => {
        if (((initialStatus === 'pending') && !!network && !!id) || initialStatus === 'failed') {
            dispatch(exports.chainEventsSlice.actions.watchEvent(event ? Object.assign(Object.assign({}, event), { updater: props.updater }) :
                { id: props.id, status: props.initialStatus, network: props.network,
                    eventType: props.eventType, updater: props.updater }));
        }
    }, [network, id, initialStatus]);
    react_1.useEffect(() => {
        kickOff(dispatch);
    }, []);
    return props.children;
}
exports.ChainEventItem = ChainEventItem;
//# sourceMappingURL=ChainEventItem.js.map